import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './SideBar.module.scss';

const SideBar = () => {
  const location = useLocation();

  return (
    <div className={`sidebar p-3 ${styles.sidebar}`}>
      <div className="nav-logo-wrapper px-5 mt-1">
        <h2>
          <img
            className="img-fluid"
            src="https://unifyapply.com/static/media/logo_unify.1892d2c8c126ae1f4ad9.png"
          />
        </h2>
      </div>
      <ul className="nav nav-pills d-flex flex-column">
        <li className="nav-title">Content</li>

        <li className="nav-item">
          <Link
            to="/backoffice/schools"
            className={`nav-link ${location.pathname.includes('schools') ? 'active' : ''}`}
            aria-current="page"
          >
            <span className="nav-icon bi bi-building" />
            <span className="content">Schools</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/backoffice/programs"
            className={`nav-link ${location.pathname.includes('forms') ? 'active' : ''}`}
            aria-current="page"
          >
            <span className="nav-icon bi bi-file-earmark-text" />
            <span className="content">Programs</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/backoffice/countries"
            className={`nav-link ${location.pathname.includes('countries') ? 'active' : ''}`}
            aria-current="page"
          >
            <span className="nav-icon bi bi-globe-americas" />
            <span className="content">Countries</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="#"
            className={`nav-link ${location.pathname.includes('tags') ? 'active' : ''}`}
            aria-current="page"
          >
            <span className="nav-icon bi bi-tag" />
            <span className="content">Tags</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/backoffice/landings"
            className={`nav-link ${location.pathname.includes('landings') ? 'active' : ''}`}
            aria-current="page"
          >
            <span className="nav-icon bi bi-file" />
            <span className="content">Landings</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link to="" className={`nav-link`} aria-current="page">
            <span className="nav-icon bi bi-box-arrow-up-right" />
            <span className="content">Blog</span>
          </Link>
        </li>
        <li className="nav-title">Leads</li>
        <li className="nav-item">
          <a className="nav-link" href="/backoffice/users">
            <span className="nav-icon bi bi-people" />
            <span className="content">All Leads</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/backoffice/documentLeads">
            <span className="nav-icon bi bi-archive" />
            <span className="content">Documents</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/backoffice/applications">
            <span className="nav-icon bi bi-window" />
            <span className="content">Applications</span>
          </a>
        </li>
        <li className="nav-title">Settings</li>
        <li className="nav-item">
          <Link
            to="/backoffice/settings"
            className={`nav-link ${location.pathname.includes('settings') ? 'active' : ''}`}
          >
            <span className="nav-icon bi bi-gear" />
            <span className="content">Configuration</span>
          </Link>
        </li>
      </ul>
      <section className="organization-card"></section>
    </div>
  );
};

export default SideBar;
